import React, { useState, useEffect, useContext } from "react";
import * as Yup from "yup";

import { ModalFormStepper } from "../../molecules/ModalFormStepper";
import { ModalStep } from "../../atoms/ModalStep";
import styles from "./AddNewLine.module.scss";
import ListModules from "../../molecules/ListModules";
import { AppContext } from "../../context/AppContext/AppContext";
import { UsersContext } from "../../context/UsersContext/UsersContext";
import {
  createLine,
  updateLine,
  getLineById,
} from "../../services/servicesLine";
import { getAllUsers } from "../../services/users";
import TextInput from "../../atoms/TextInput";
import SelectOption from "../../atoms/SelectOption";
import { SubmoduleList } from "../../molecules/SubmoduleList";
import { id } from "date-fns/locale";
import PillInputNew from "../PillInputNew";
import ErrorMessage from "../../atoms/ErrorMessage";


const validateSchema = Yup.object({
  name: Yup.string()
    .required("Campo obligatorio"),
  leader: Yup.string().required("Campo obligatorio"),
});
const validateSchema2 = Yup.object({
  module: Yup.array()
    .min(1, "Campo obligatorio").required("Campo obligatorio"),
  managers: Yup.array()
    .min(1, "Campo obligatorio"),
});

// const message = Yup.array().min(1, "Campo obligatorio");

export const AddNewLine = ({
  onClose,
  edit = false,
  setStatus,
  setIsLoading,
  setOpenCreateNotification,
  setError400,
  setNewLineRender,
  newLineRender,
}) => {

  const [lead, setLead] = useState([]);
  const [modulesPlan, setModulesPlan] = useState([]);
  const [valueModules, setValueModule] = useState([]);
  const [valueManagers, setValueManagers] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: "",
    leader: "",
    module: [],
    selectedManager: [],
  });

  const { user, modules, modulesMixer } = useContext(AppContext);
  const { userList, setUserList } = useContext(UsersContext);



  useEffect(() => {
    async function fetchData() {
      const res = await getAllUsers();
      setLead(res.response);
      setUserList(
        res.response.map((user) => {
          return {
            value: user.id,
            label: user.name,
          };
        })
      );
    }
    fetchData();
  }, []);

  const multiFilter = (array, filters) => {
    let filterKeys = Object.keys(filters);

    return array.filter((item) =>
      filterKeys.every((key) => filters[key].indexOf(item[key]) === -1)
    );
  };

  useEffect(() => {
    const fetchModules = async () => {
      const listModules = modules.map((module) => ({
        key: module.id,
        value: module.label,
      }));
      const filters = { key: [7, 8, 9, 12] };
      const arrayModules = multiFilter(listModules, filters);
      const list = arrayModules?.map((element) => ({
        value: element.key,
        label: element.value,
      }));
      setModulesPlan(list);
    };
    fetchModules();
  }, []);

  const missingModules = modulesPlan?.filter((element) => !valueModules.some((sub) => sub.value === element.value));
  const missingManagers = userList?.filter((element) => !valueManagers.some((sub) => sub.value === element.value));


  return (
    <ModalFormStepper
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={async ({values}) => {
        const defaultData = {
          created_by: user.email,
          name: values.name,
          leader: values.leader,
          managers: valueManagers.map(
            (manager) => manager.value
          ),
          module: valueModules.map((module) => module.value),
        };
        setIsLoading(true);
        if (!edit) {
         const data = await createLine(defaultData);
         setStatus(data.status);
         setOpenCreateNotification(true);
         onClose()
         setIsLoading(false);
         setNewLineRender(!newLineRender)
         if (data.status === 400) {
           setError400(data.data.data.response[0].message);
         }
        }
      }}
    >
      <ModalStep validationSchema={validateSchema}>
        <h2 className={styles.title}>Nueva línea</h2>
        <div className={styles.inputNameContainer}>
          <TextInput
            label="Nombre"
            name="name"
            type="text"
            className={styles.label}
            classInput={styles.classInput}
            customInputContainer={styles.customInputContainer}
            placeholder="Nombre de línea"
          />
        </div>
        <div className={styles.inputSelectContainer}>
          <SelectOption
            label="Líder"
            name="leader"
            classNameL={styles.label}
            classInput={styles.classInput}
            errorMessageStyle={styles.errorMessageStyle}
            placeholder="Nombre de línea"
          >
          <option value="" disabled selected>
            Seleccionar
          </option>
          {lead.map((user) => (
            <option value={user.id} key={user.id}>
              {user.name}
            </option>
          ))}
          </SelectOption>
        </div>
      </ModalStep>
      <ModalStep validationSchema={validateSchema2}>
        <h2 className={styles.title}>Nueva línea</h2>
        <ListModules
          name="module"
          options={missingModules}
          setValues={setValueModule}
          defaultValue={valueModules}
        />
        <div className={styles.listContainer}>
          <label htmlFor="selectedManager" className={styles.subTitle}> Responsables </label>
          <div className={styles.pillinputContainer}>
          <PillInputNew
            typeValue="string"
            options={missingManagers}
            name="selectedManager"
            setValue={setValueManagers}
            submodule={valueManagers}
          />
          </div>
        </div>
      </ModalStep>
    </ModalFormStepper>
  );
};
